import { SERVER } from './env'
import axios from 'axios';

axios.defaults.timeout = 15000;

// 固定url
export const URL_UPLOAD = SERVER + '/files/upload'
export const URL_DOWNLOAD = SERVER + '/files/download'

// 调用axios,返回请求数据
export const URL_GETCOUNTRYCODE = params => { return axios.get(`${params}`, {withCredentials: false}); };   //获取国家地区代码
export const URL_SAVEPERSONINFO = params => { return axios.post(`${SERVER}/api/getsomedata`, params); };  //保存第一页数据
export const URL_REGISTER = params => { return axios.post(`${SERVER}/api/register`, params); }; // 保存表单所有数据
export const URL_VERIFY = params =>{ return axios.post(`${SERVER}/api/verify`, params); }
export const URL_CREATELEAD = params => { return axios.post(`${SERVER}/api/createlead`, params); };
export const URL_CREATECAMPAIGNLEAD = params => { return axios.post(`${SERVER}/api/createCampaignlead`, params); };
// 查询邮箱信息
export const URL_QUERY_INFO_BY_EMAIL = params => { return axios.post(`${SERVER}/api/queryInfoByEmail`, params); };
// 生成lead和campaignlead
export const URL_CREATE_LEAD_AND_CAMPAIGN_LEAD = params => { return axios.post(`${SERVER}/api/createLeadAndCampaignLead`, params); };
// 更新lead信息
export const URL_UPDATELEAD = params => { return axios.post(`${SERVER}/api/updateLead`, params); };

// 检查销售ID
export const URL_IBCODE = params => { return axios.post(`${SERVER}/api/ibcode`, params); };
// 查询ib黑名单
export const URL_CHECKBLACKIBCODE = params => { return axios.post(`${SERVER}/api/checkBlackList`); };

function request(options) {
    return new Promise((resolve, reject) => {
        axios(options)
            .then(function (response) {
                if(response.data.code == 200){
                    resolve(response.data.data)
                }else{
                    reject(response.data.msg)
                }
            })
            .catch(function (error) {
                reject(error)
            });
    })
}
window.api = window.api || {};
window.api = {
    //POST 写法request({ method: 'post',
    //  url: '/user/12345',
    //  data: {
    //    firstName: 'Fred',
    //    lastName: 'Flintstone'
    //  }})
}
export default window.api;



// WEBPACK FOOTER //
// ./src/api/api.js